export default "__VITE_ASSET__dR6eD9gP__"